import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import CommandResult from "../../Common/Models/CommandResult";
import RawGenericExportMappingLookup from "../RawGenericExportMappings/Models/Lookups/RawGenericExportMappingLookup";
import CreateRawGenericExportMappingCommand from "../RawGenericExportMappings/Models/Commands/CreateRawGenericExportMappingCommand";
import UpdateRawGenericExportMappingCommand from "../RawGenericExportMappings/Models/Commands/UpdateRawGenericExportMappingCommand";
import RawGenericExportMappingSearchCriteria from "../RawGenericExportMappings/Models/Queries/RawGenericExportMappingSearchCriteria";

export interface IRawGenericExportMappingApiClient {
    getRawGenericExportMappingsPagedList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<RawGenericExportMappingSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<RawGenericExportMappingLookup>>>;
    getRawGenericExportMappingById(rawGenericExportMappingId: number): AxiosPromise<Model.PlainObject<RawGenericExportMappingLookup>>;
    addNewRawGenericExportMapping(command: Model.PlainObject<CreateRawGenericExportMappingCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    updateRawGenericExportMapping(command: Model.PlainObject<UpdateRawGenericExportMappingCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class RawGenericExportMappingApiClient extends Data.ApiClientBase implements IRawGenericExportMappingApiClient {

    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/RawGenericExportMapping`)
    }

    public getRawGenericExportMappingsPagedList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<RawGenericExportMappingSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<RawGenericExportMappingLookup>>> {
        return this.axios.get(`${this.apiPath}/GetRawGenericExportMappingsPagedList?${Utils.getQueryString(payload)}`);
    }

    public getRawGenericExportMappingById(rawGenericExportMappingId: number): AxiosPromise<Model.PlainObject<RawGenericExportMappingLookup>> {
        return this.axios.get(`${this.apiPath}/GetRawGenericExportMappingById`, { params: { rawGenericExportMappingId: rawGenericExportMappingId }})
    }

    public addNewRawGenericExportMapping(command: Model.PlainObject<CreateRawGenericExportMappingCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/AddNewRawGenericExportMapping`, command);
    }
 
    public updateRawGenericExportMapping(command: Model.PlainObject<UpdateRawGenericExportMappingCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/UpdateRawGenericExportMapping`, command);
    }
}